<template>
  <v-btn-form :title="title" @close="cancel()">
     <v-form v-model="valid" ref="form">
          <v-card-text>
            <v-layout row wrap>
              <v-text-field v-if="!parentId" name="lastName" v-model = "item.lastName" label="Фамилия" type="text" :rules="this.lastnameNotNullRule.concat(this.ruleNameRu)"></v-text-field>
              <v-text-field v-if="!parentId" name="firstName" v-model = "item.firstName" label="Имя" type="text" :rules="ruleNameRu"></v-text-field>
            </v-layout>  
            <v-layout row wrap>
              <v-text-field v-if="!parentId" name="middleName" v-model = "item.middleName" label="Отчество" type="text" :rules="ruleNameRu" ></v-text-field>          
              <v-text-field v-if="!parentId" name="innfl" v-model = "item.innfl" label="Инн" type="text" :rules="innflRules"></v-text-field>
            </v-layout>
             <v-layout row wrap>
             <v-text-field v-model="item.name" name="name" label="Название" type="text"></v-text-field>
            </v-layout>
            <v-layout row wrap>
              <v-chips-field 
                emptyChip="Организация"
                solo flat
                @remove="clearInn" 
                @click="selectInn" 
                :items="chipsItems" 
                :chipSize="getIsMobile ? 12 : 25" > 
              </v-chips-field>
              <v-text-field v-model="item.position" name="position" label="Должность" type="text" ></v-text-field>              
              </v-layout>
             <v-layout row wrap>
              <v-text-field v-model="item.email" name="email" label="Эл. почта" type="text" :rules="emailRules"></v-text-field>
              <v-text-field v-model="item.phone" :rules="phoneRules" name="phone" label="Тел." type="text" @change="item.phone = formatPhone($event)"></v-text-field>
             </v-layout>
            <v-layout row wrap>
           </v-layout>
             <v-text-field v-model="item.address" name="address" label="Адрес" type="text"></v-text-field>
             <v-text-field v-if="parentId" v-model="item.notes" name="notes" label="Заметки" type="text"></v-text-field>
          </v-card-text>
      </v-form>
    <template #actions>
      <v-btn v-show="!isNew" @click="save">Сохранить</v-btn>
      <v-btn v-show="!isNew" @click="remove">Удалить</v-btn>
      <v-btn v-show="isNew" :disabled='!valid' @click="add">Добавить</v-btn>
      <v-spacer></v-spacer>
    </template>
   </v-btn-form> 
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  // import server from '../../api/server'
  import formats from '../../api/formats'
  // import dialogs from '../common/dialogs'
  import vChipsField from '../common/ChipsField.vue'
  import client from '../client'
  import vBtnForm from '../common/BtnForm'

  export default {
    name: 'contact-form',
    components: {vBtnForm, vChipsField},
    data: () => ({
      valid: false,
      company: null,
      item: {},
      phoneRules: [v => !v || formats.isPhone(formats.formatPhone(v)) || 'Формат номера +7(921)1234567'],
      emailRules: [v => !v || formats.isEmail(v) || 'Неверный формат эл. почты'],
      innflRules: [v => !v || formats.isInnfl(v) || 'Неверный формат ИНН'],
      snilsRules: [v => !v || formats.isSnils(v) || 'Неверный формат СНИЛС'],
      ruleNameRu: [v => !v || formats.isNameRu(v, 60) || 'Допустимы русские буквы'],
      lastnameNotNullRule: [v => !!v || 'Введите фамилию']
    }),
    props: {
      itemId: {
        type: String,
        default: null
      },
      parentId: {
        type: String,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      }
    },
    created () {
    },
    mounted () {
      this.fetchData(this.parentId, this.itemId)
    },
    watch: {
      itemId: function (newVal, oldVal) { // watch it
        this.fetchData(this.parentId, this.itemId)
      }
    },
    computed: {
      ...mapGetters({
        getIsMobile: 'getIsMobile'
      }),
      isEdit () {
        return true
      },
      isNew () {
        return this.itemId === null
      },
      title () {
        return this.isNew ? 'Добавить контакт' : this.isEdit ? 'Изменить атрибуты' : 'Информация о контакте'
      },
      chipsItems () {
        const getHint = company => {
          return `${company.name} (ИНН: ${formats.formatInn(company.inn)})`
        }
        const getError = company => null
        if (this.company && this.item && this.item.companyRefCode === this.company.ref) {
          let c = this.company
          return [{value: c.ref, text: c.caption, hint: getHint(c), error: getError(c)}]
        }
        if (this.item && this.item.companyRefCode) {
          return [{value: this.item.companyRefCode + '', text: this.item.companyRefCode, hint: 'Чтобы видеть название компании, добавьте компанию в Мои Контрагенты', error: null}]
        }
        return []
      }
    },
    methods: {
      formatPhone (v) {
        return formats.formatPhone(v)
      },
      fetchData (parentId, itemId) {
        if (parentId && itemId) {
          this.$store.dispatch('getPeopleIndividual', parentId).then(data => {
            let contact = data.contacts.find(contact => formats.compareString(itemId, contact.id) === 0)
            delete data.contacts
            this.item = Object.assign(this.getItemNew(), data)
            if (contact) {
              this.item = Object.assign(this.item, contact)
              this.fetchCompany(this.item.companyRefCode)
              // console.log('fetchData1', contact, this.item)
            }
          })
        } else {
          this.item = this.getItemNew()
        }
      },
      fetchCompany (companyRefCode) {
        return new Promise((resolve, reject) => {
          if (!companyRefCode) {
            this.company = null
            resolve(null)
          }
          client.getCachedRefs([companyRefCode], (companies) => {
            this.company = companies.length > 0 ? companies[0] : null
            resolve(this.company)
          })
        })
      },
      add () {
        if (this.$refs.form.validate()) {
          let item = this.item
          let name = item.name
          if (!this.parentId) {
            this.$store.dispatch('updatePeopleIndividual', {
              id: null,
              individual: {lastName: item.lastName, firstName: item.firstName, middleName: item.middleName, innfl: item.innfl},
              contact: {id: this.itemId, name: name, companyRefCode: item.companyRefCode, position: item.position, phone: item.phone, email: item.email, address: item.address, notes: item.notes}
            }).then((id) => {
              this.$emit('change', id)
              this.cancel()
            })
          } else {
            this.$store.dispatch('updatePeopleIndividual', {
              id: this.parentId,
              contact: {id: this.itemId, name: name, companyRefCode: item.companyRefCode, position: item.position, phone: item.phone, email: item.email, address: item.address, notes: item.notes}
            }).then(() => {
              this.$emit('change', this.parentId)
              this.cancel()
            })
          }
        }
      },
      cancel () {
        this.item = Object.assign({}, this.getItemNew())
        this.$emit('close')
      },
      save () {
      },
      remove () {
      },
      selectInn () {
        client.selectRef(this, (companies) => {
          this.item.companyRefCode = companies.length > 0 ? companies[0].ref : null
          this.fetchCompany(this.item.companyRefCode).then(company => {
            this.item = Object.assign({}, this.item, {position: null})
          })
        }, () => {}, true, true)
      },
      clearInn () {
        delete this.item.companyRefCode
        this.fetchCompany(null)
      },
      getItemNew () {
        return {
          individualId: null,
          firstName: null,
          middleName: null,
          lastName: null,
          innfl: null,
          companyRefCode: null,
          phone: null,
          email: null,
          adderess: null,
          notes: null
        }
      }
    }

  }

</script>




// WEBPACK FOOTER //
// ContactForm.vue?33466cbf